import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import TextField2T from "../textfields/TextField2T";
import PrimaryButton from "../buttons/PrimaryButton";
import DropDownGPT03 from "../dropdowns/DropDownGTP03";

function NewInvoiceForm({
  setStep,
  article_configuration,
  mobile,
  setArticle_configuration,
  disabled = false,
}) {
  const updateConfigKey = (key, value) => {
    setArticle_configuration({ ...article_configuration, [key]: value });
  };

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  return (
    <div className=" w-full max-w-c500 relative h-fit flex select-none ">
      {/* Left Column: Takes all available space */}

      <div className="flex flex-col gap-2 h-fit  w-full items-start justify-center  ">
        <DropDownGPT03
          force_down={true}
          className={"w-full"}
          value={article_configuration.timeline}
          onChange={(e) => updateConfigKey("timeline", e.value)}
          items={[
            { value: "pc", label: "Phase Permis de construire" },
            {
              value: "building",
              label: "En cours de construction",
            },
          ]}
          label="Avancement du projet"
        ></DropDownGPT03>
        <DropDownGPT03
          force_down={true}
          className={"w-full"}
          value={article_configuration.type}
          onChange={(e) => updateConfigKey("type", e.value)}
          items={[
            { value: "house", label: "Construction maison" },
            {
              value: "extension",
              label: "Extension ou surélévation",
            },
            { value: "renovation", label: "Rénovation" },
            { value: "tertiaire", label: "Tertiaire" },
            { value: "autre", label: "Autre" },
          ]}
          label="Type de projet"
        ></DropDownGPT03>
        {article_configuration.type === "extension" && (
          <div className="flex flex-row gap-2 w-full   ">
            <TextField2T
              value={article_configuration.surface}
              onChange={(e) => updateConfigKey("surface", e.target.value)}
              placeholder="Surface habitable"
              type="number"
              label="Surface de l'extension'"
            ></TextField2T>
          </div>
        )}
        {article_configuration.type === "house" && (
          <div className="flex flex-row gap-2 w-full   ">
            <TextField2T
              value={article_configuration.surface}
              onChange={(e) => updateConfigKey("surface", e.target.value)}
              placeholder="Surface habitable"
              type="number"
              label="Surface habitable"
            ></TextField2T>
            <TextField2T
              value={article_configuration.units}
              onChange={(e) => updateConfigKey("units", e.target.value)}
              placeholder="Nombre de maisons"
              type="number"
              label="Nombre de maisons"
            ></TextField2T>
          </div>
        )}{" "}
        {article_configuration.type === "house" && (
          <div className="flex flex-row gap-2 w-full   ">
            <DropDownGPT03
              className={"w-full"}
              value={article_configuration.author}
              onChange={(e) => updateConfigKey("author", e.value)}
              items={[
                { value: "locatif", label: "En mon nom" },
                {
                  value: "societe",
                  label: "Au nom d'une société (SCI, SARL ...)",
                },
              ]}
              label="Auteur de la demande"
            ></DropDownGPT03>
          </div>
        )}
        {article_configuration.type === "renovation" && (
          <div className="flex flex-row gap-2 w-full   ">
            <TextField2T
              value={article_configuration.surface}
              onChange={(e) => updateConfigKey("surface", e.target.value)}
              placeholder="Surface habitable"
              type="number"
              label="Surface de la rénovation"
            ></TextField2T>
          </div>
        )}
        {article_configuration.type === "tertiare" && (
          <div className="flex flex-row gap-2 w-full   ">
            <TextField2T
              value={article_configuration.surface}
              onChange={(e) => updateConfigKey("surface", e.target.value)}
              placeholder="Surface habitable"
              type="number"
              label="Surface du batiment"
            ></TextField2T>
          </div>
        )}
        {!disabled && (
          <div className="flex flex-row justify-end w-full">
            <PrimaryButton
              mobile={mobile}
              disabled={
                !article_configuration.timeline ||
                !article_configuration.type ||
                article_configuration.type === "" ||
                (article_configuration.type === "extension" &&
                  !article_configuration.surface) ||
                (article_configuration.type === "house" &&
                  (!article_configuration.surface ||
                    !article_configuration.units ||
                    !article_configuration.author)) ||
                (article_configuration.type === "renovation" &&
                  !article_configuration.surface) ||
                (article_configuration.type === "tertiare" &&
                  !article_configuration.surface)
              }
              onClick={() => setStep("infos-1")}
              className="w-fit"
            >
              Valider
            </PrimaryButton>
          </div>
        )}
      </div>
    </div>
  );
}

export default NewInvoiceForm;
